import { ColumnsType } from 'antd/lib/table';
import { TFunction } from 'i18next';
import { formatUserName } from 'utils/helpers';
import { IRecipe, IRecipeResource } from './types';

export const getRecipeColumns = (t: TFunction) => {
  const columns: ColumnsType<IRecipe> = [
    {
      title: t('Recipe.Title', 'Title'),
      dataIndex: 'name',
      key: 'name',
      sorter: true,
    },
    {
      title: t('Common.Culture', 'Culture'),
      dataIndex: ['culture', 'name'],
      key: 'culture',
      sorter: false,
    },
    {
      title: 'BBCH',
      dataIndex: 'bbchFrom',
      key: 'bbchFrom',
      sorter: true,
      render: (_: unknown, recipe) => `${recipe.bbchFrom} - ${recipe.bbchTo}`,
    },
    {
      title: t('Recipe.Creator', 'Creator'),

      dataIndex: ['createdBy', 'email'],
      key: 'createdBy',
      sorter: false,
      render: (_, recipe) => formatUserName(recipe.createdBy),
    },
    {
      title: t('Recipe.ResourcesCount', 'Resources count'),
      dataIndex: 'resources',
      key: 'resources',
      sorter: false,
      render: (resources: IRecipeResource[]) => resources.length,
    },
  ];

  return columns;
};

export const getEditRecipeFormInitialValues = (recipe: IRecipe) => {
  const { name, category, culture, bbchFrom, bbchTo, description } = recipe;

  const values = {
    name,
    categoryId: category.id,
    cultureId: culture.id,
    bbchFrom,
    bbchTo,
    description,
  };

  return values;
};
